//@ts-nocheck
import React, {
    createContext,
    Dispatch,
    PropsWithChildren,
    SetStateAction,
    useContext,
    useEffect,
    useLayoutEffect,
    useState
} from "react";

import {
    BundleProvisioningStatusType,
    ConfirmationPageOverlayVariants,
    FeatureFlags
} from ".";

export type PageOverlayModalProviderProps = {
    readonly isModalOpen: boolean;
    readonly setIsModalOpen: Dispatch<SetStateAction<boolean>>;
    readonly showOffers: boolean;
    readonly isModalEnabled: boolean;
    readonly pageOverlayModalVariant?: ConfirmationPageOverlayVariants;
};

const PageOverlayModalContext = createContext<PageOverlayModalProviderProps>({
    isModalOpen: false,
    setIsModalOpen: () => undefined,
    showOffers: false,
    isModalEnabled: false,
    pageOverlayModalVariant: undefined
});

export function usePageOverlayModal() {
    return useContext(PageOverlayModalContext);
}

// USC-720 Bundles Modal
export const PageOverlayModalProvider = ({
    isModalEnabled,
    bundleProvisioningStatus,
    children,
    featureFlags
}: PropsWithChildren<{
    isModalEnabled: boolean;
    bundleProvisioningStatus: BundleProvisioningStatusType;
    featureFlags: FeatureFlags;
}>) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showOffers, setShowOffers] = useState(false);
    const pageOverlayModalVariant = featureFlags.enableConfirmationPageOverlay;
    // Open modal 4s after confirmation page loads
    useLayoutEffect(() => {
        if (isModalEnabled && !isModalOpen) {
            setTimeout(() => {
                setIsModalOpen(true);
                setShowOffers(true);
            }, 4000);
        }
    }, []);

    // After second product is added hide the see offers/free bundles view
    useEffect(() => {
        if (isModalEnabled && bundleProvisioningStatus === "payload-ready") {
            setShowOffers(false);
        }
    }, [bundleProvisioningStatus]);

    return (
        <PageOverlayModalContext.Provider
            value={{
                isModalOpen,
                setIsModalOpen,
                showOffers,
                isModalEnabled,
                pageOverlayModalVariant
            }}
        >
            {children}
        </PageOverlayModalContext.Provider>
    );
};
